import {createSlice} from "@reduxjs/toolkit";


const AuthSlice = createSlice({
    name: "user",
    initialState: {
        isAuthenticated: false,
        isStaffUser: false,
        userInfo: localStorage.getItem("userInfo") || {},
        profilePicURL: null,
        refreshToken: localStorage.getItem("refresh") || null,
        accessToken: null,
        userProjects: [],
        newsCount: 0,
        phoneNo: null,
        manageInfoId: null,
    },
    reducers: {
        setIsAuthenticated: (state, action) => {
            state.isAuthenticated = action.payload
        },
        setAccessToken:(state,action) => {
            // state.isAuthenticated = action.payload.isAuthenticated
            state.isStaffUser = true
            state.accessToken = action.payload.accessToken;
        },
        setUserProjects: (state, action) => {
            state.userProjects = action.payload;

        },
        setPhoneNo: (state, action) => {
            state.phoneNo = action.payload
        },
        setManageInfoId: (state, action) => {
            state.manageInfoId = action.payload.manageInfoId
            state.isStaffUser = action.payload.user.isStaff
        },
        loginUser: (state, action) => {
            const {payload} = action;
            if (payload) {
                state.isAuthenticated = true;
                state.authorizedUser = payload.userInfo;
                state.refreshToken = payload.refreshToken;
                state.accessToken = payload.accessToken;
                state.userInfo = payload.userInfo;
                state.isStaffUser = payload.userInfo?.isStaff || false

                localStorage.setItem("isAuthenticated", String(true));
                localStorage.setItem("refresh", payload.refreshToken)
                localStorage.setItem("userInfo", JSON.stringify(payload.userInfo))
            }
        },
        logoutUser: (state, action) => {
            state.isAuthenticated = false;
            state.isStaffUser = false;
            state.refreshToken = null;
            state.accessToken = null;
            state.userInfo = null;

            localStorage.removeItem("isAuthenticated");
            localStorage.removeItem("refresh")
            localStorage.removeItem("userInfo")

        },
        setNewsCount: (state, action) => {
            state.newsCount = action.payload
        }

    }
});

export const {
    loginUser,
    logoutUser,
    setUserProjects,
    setNewsCount,
    setIsAuthenticated,
    setAccessToken,
    setPhoneNo,
    setManageInfoId,
} = AuthSlice.actions;
export const authReducer = AuthSlice.reducer;

